import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLastUsed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.95331 10.0014C3.95331 5.79311 7.42831 2.38478 11.67 2.50144C15.5783 2.60978 18.845 5.87644 18.9533 9.78478C19.07 14.0264 15.6616 17.5014 11.4533 17.5014C9.71165 17.5014 8.11998 16.9098 6.85331 15.9098C6.46165 15.6098 6.43665 15.0181 6.78665 14.6681C7.08665 14.3681 7.55331 14.3431 7.88665 14.6014C8.86998 15.3764 10.1116 15.8348 11.4533 15.8348C14.7033 15.8348 17.3283 13.1764 17.2866 9.91811C17.245 6.81811 14.6366 4.20978 11.5366 4.16811C8.26998 4.12644 5.61998 6.75144 5.61998 10.0014H7.11165C7.48665 10.0014 7.66998 10.4514 7.41165 10.7098L5.08665 13.0431C4.91998 13.2098 4.66165 13.2098 4.49498 13.0431L2.16998 10.7098C1.90331 10.4514 2.08665 10.0014 2.46165 10.0014H3.95331ZM10.62 7.29311C10.62 6.95144 10.9033 6.66811 11.245 6.66811C11.5866 6.66811 11.87 6.95144 11.87 7.28478V10.1181L14.27 11.5431C14.5616 11.7181 14.6616 12.1014 14.4866 12.4014C14.3116 12.6931 13.9283 12.7931 13.6283 12.6181L11.0283 11.0764C10.7783 10.9264 10.62 10.6514 10.62 10.3598V7.29311Z",
		fill: "currentColor"
	})
});
export default SvgLastUsed;
